import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Page } from "../Page";
import { CustomerDataRetentionSettings } from "@/components/Customers/Settings/CustomerDataRetentionSettings";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";

export const CustomerSettingsPage = () => {
    const history = useHistory();

    const handleContactsClick = () => {
        history.push("/customers/contacts");
    };

    return (
        <Page title="Customer Settings">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Customers</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleContactsClick}>Contacts</Breadcrumb.Item>
                        <Breadcrumb.Item>Settings</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <CustomerDataRetentionSettings />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
